<div class="overflow-hidden shadow rounded">
    <div class="px-4 py-5 sm:p-6 relative h-auto">
        @if(explainer){
        <div class="absolute top-2 right-2">
            <ng-icon name="faCircleQuestion" class="cursor-pointer"
                (click)="explainerModal.toggleModal()"></ng-icon>
        </div>
        }
        <dl class="flex-none">
            <dt class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-300 truncate">
                {{ title }}
            </dt>
            <dd class="mt-1 text-3xl leading-9 font-semibold text-primary">
                {{ value }}
            </dd>
        </dl>
    </div>
</div>
<app-modal #explainerModal>
    <div class="flex flex-row items-center w-full h-full">
        <div class="flex flex-col items-center w-full text-center">
            <img src="./assets/img/penguin-lightbulb.webp" alt="Pinguin mit Glühbirne"
                class="object-cover mb-10 w-40 h-40 rounded-full" />
            <p class="px-20 text-center">{{ explainer }}</p>
            <button class="blue-button mt-10 w-20" (click)="explainerModal.toggleModal()">OK</button>
        </div>
    </div>
</app-modal>